var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.payProps.visible)?_c('desktop-pay',{attrs:{"lang-id-data":_vm.$store.state.locale.langIdData,"store-lang":_vm.$store.state.locale.locale,"desk-pay":_vm.payProps},on:{"close":_vm.closePayModal}}):_vm._e(),_vm._v(" "),_c('mobile-pay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }